import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PropertyThumb = ({ orderId, show, className = "h-10 w-14", testId }) => {
  const [failed, setFailed] = useState(false);
  if (!show || failed) return null;
  return (
    <img
      src={`${BACKEND_URL}/api/property-thumbs/${orderId}`}
      alt="property"
      loading="lazy"
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-md bg-secondary object-cover ${className}`}
      data-testid={testId || `property-thumb-${orderId}`}
    />
  );
};
